export default __webpack_public_path__ + "static/media/alamo-arte-1.5f0a1f53.webp";